import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { const u = await login(email, password); nav(u.role === "admin" ? "/admin" : "/"); }
    catch { toast.error("Invalid email or password"); }
    finally { setBusy(false); }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-16">
      <div className="eyebrow mb-2 text-center">Account</div>
      <h1 className="font-serif text-3xl md:text-4xl text-[#0B1F3A] text-center mb-8">Welcome back</h1>
      <form onSubmit={submit} className="space-y-4 bg-white p-6 gold-border">
        <label className="block">
          <div className="text-xs text-[#1E293B]/60 mb-1">Email</div>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="w-full border px-3 py-2.5" style={{ borderColor: "rgba(212,175,55,0.4)" }} data-testid="login-email" />
        </label>
        <label className="block">
          <div className="text-xs text-[#1E293B]/60 mb-1">Password</div>
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="w-full border px-3 py-2.5" style={{ borderColor: "rgba(212,175,55,0.4)" }} data-testid="login-password" />
        </label>
        <button disabled={busy} className="w-full bg-[#0B1F3A] text-[#FFF9E6] py-3 tracking-widest uppercase text-sm disabled:opacity-60" data-testid="login-submit">{busy ? "…" : "Sign in"}</button>
        <div className="text-xs text-center text-[#1E293B]/60">New here? <Link to="/register" className="underline text-[#0B1F3A]" data-testid="to-register">Create account</Link></div>
      </form>
    </div>
  );
}
